/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    ISignInItem,
    ISignInLoading,
    ISignInSocialAccount,
    ISignInSocialItem,
    ISignInB2BAccount,
    ISignInB2BItem
    // ISignInViewProps
} from '@msdyn365-commerce-modules/account-management/src/modules/sign-in/./sign-in';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { ReactElement } from 'react';

const LocalAccount: React.FC<any> = ( signInLocalAccount,resources) => {
    return (
        <Node {...signInLocalAccount.localAccount}>
            {signInLocalAccount.items &&
            signInLocalAccount.items.map((item: ISignInItem) => {
                return (
                    <Node key={item.key} {...item.wrapper}>
                        {item.label}
                        {item.error}
                        {item.input}
                    </Node>
                );
            })}
            {signInLocalAccount.forgetPassword}
            {signInLocalAccount.disclaimer}
            {signInLocalAccount.error}
            {signInLocalAccount.signInButton && React.cloneElement(signInLocalAccount.signInButton as ReactElement,{'text':resources.newLoginButtonText})}
        </Node>
    );
};

const SocialAccount: React.FC<ISignInSocialAccount> = ({ socialAccounts, items }) => {
    return (
        <Node {...socialAccounts}>
            {items &&
                items.map((item: ISignInSocialItem) => {
                    return (
                        <Node key={item.key} {...item.button}>
                            {item.image}
                            {item.text}
                        </Node>
                    );
                })}
        </Node>
    );
};

const B2BAccount: React.FC<ISignInB2BAccount> = ({ socialAccounts, items }) => {
    return (
        <Node {...socialAccounts}>
            {items &&
                items.map((item: ISignInB2BItem) => {
                    return (
                        item && (
                            <Node key={item.key} {...item.button}>
                                {item.text}
                            </Node>
                        )
                    );
                })}
        </Node>
    );
};

const SignInLoading: React.FC<ISignInLoading> = ({ modal, modalBody, icon, message }) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};

const SignInView: React.FC<any> = props => {
    const {
        signIn,
        viewState,
        loading,
        defaultAADConainer,
        aadConainer,
        signInSection,
        signUpSection,
        signInSectionHeading,
        signInLocalAccount,
        signInSocialAccount,
        // signUpSectionHeading,
        signInB2BAccount,
        // signUpDescription,
        signUpLink,
        resources,
        config
    } = props;

    return (
        <Module {...signIn} style={{'--invalid-error-image': `url(${config.invalidErrorImage?.src??''})`}}>
            {viewState.isShowLoading && <Node {...defaultAADConainer} />}
            {viewState.isShowLoading && <SignInLoading {...loading} />}
            <Node {...aadConainer}>
                <Node {...signInSection}>
                    {signInSectionHeading}
                    {LocalAccount(signInLocalAccount,resources)}
                    {SocialAccount(signInSocialAccount)}
                    {B2BAccount(signInB2BAccount)}
                </Node>
                <Node {...signUpSection}>
                    <div style={{
                        '--Banner-desktop-image-url': `url(${config.signInBannerDesktopImageURL?.src??''})`,
                        '--Banner-mobile-image-url': `url(${config.signInBannerMobileImageURL?.src??''})`
                    } as React.CSSProperties}>
                        <div>{ArrayExtensions.hasElements(props.slots.signUpCard) && props.slots.signUpCard[0]}</div>
                        <div>{signUpLink}</div>
                    </div>
                    {/*{signUpSectionHeading}*/}
                    {/*{signUpDescription}*/}
                </Node>
            </Node>
        </Module>
    );
};

export default SignInView;
